import controller from "webforms/formio/formio-browser.controller";
import templateUrl from "webforms/formio/formio-browser.htm";

export default {
  bindings: {
    hideSettings: "<?",
    hideToolbar: "<?",
  },
  controller,
  templateUrl,
};
